import { Suspense } from 'react';

import { Route, Switch } from 'react-router-dom';

import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';
import MainContentPending from '../pageStructure/mainContentPending';
import { AccountActivationConfirmation } from './accountActivation/AccountActivationConfirmation';
import {
    ACCOUNT_CONFIRMATION_URL,
    CONSENT_REVIEW_URL,
    CREDIT_CARD_BASE_URL,
    ONBOARDING_BASE_URL,
    PREFERENCES_URL
} from './constants';
import { CreditCardDashboard } from './dashboard/CreditCardDashboard';
import { OnboardingRoutes } from './onboarding/OnboardingRoutes';
import { ConsentReviewView } from './preferences/consent/review/ConsentReviewView';
import { PreferencesView } from './preferences/PreferencesView';

export const CreditCard = () => {
    return (
        <Switch>
            <Route path={ONBOARDING_BASE_URL}>
                <OnboardingRoutes />
            </Route>
            <Route exact path={ACCOUNT_CONFIRMATION_URL}>
                <AccountActivationConfirmation />
            </Route>
            <Route exact path={`${CREDIT_CARD_BASE_URL}/`}>
                <CreditCardDashboard />
            </Route>
            <Route exact path={`${PREFERENCES_URL}`}>
                <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                    <Suspense fallback={<MainContentPending />}>
                        <PreferencesView />
                    </Suspense>
                </ErrorBoundary>
            </Route>
            <Route exact path={CONSENT_REVIEW_URL}>
                <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                    <Suspense fallback={<MainContentPending />}>
                        <ConsentReviewView />
                    </Suspense>
                </ErrorBoundary>
            </Route>
        </Switch>
    );
};
